function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from "react";
import { useNavigationList } from "@sprout/list-navigation";
import { Flex } from "sprout-ui-primitives";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import { getIsLargePointerDevice } from "sprout-ui-dom/dist/utils";
import useTopicPageSectionMainToggle from "../../graphql/mutations/useTopicPageSectionMainToggle";
import { useTopicPage } from "../../TopicPageContext";
import { useTopicPageViewsTopicEditor } from "../TopicPageViewsTopicEditorContext";
import TopicPageViewsTopicListSectionWithListNavigation from "./TopicPageViewsTopicListSectionWithListNavigation";
const SUPPORTED_ACTIONS = [
    "OPEN",
    "OPEN_EXTERNAL",
    "EXPAND",
    "COLLAPSE",
    "EDIT_TOPIC", 
];
const TopicPageViewsTopicListSections = (props)=>{
    const { sections , isSortEnabled , topicId , expandable , __hideLater  } = props;
    const mainToggle = useTopicPageSectionMainToggle();
    const showSnackbar = useSnackbar();
    const handleExpand = useCallback((section, mainIsOpen)=>{
        const { id , nodeId , userPreferences  } = section;
        mainToggle({
            itemId: id,
            itemNodeId: nodeId,
            userPreferencesNodeId: userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.nodeId,
            mainIsOpen
        }).catch(()=>{
            showSnackbar.error();
        });
    }, [
        showSnackbar,
        mainToggle
    ]);
    const { dispatch  } = useTopicPageViewsTopicEditor();
    const { isPartOfTopic  } = useTopicPage();
    /**
   * Why is this needed? To handle the appearances of "optimisticResponse".
   * `MoveItemsDialog` will optimistically return sections with
   * the new `parentTopicId`.
   *
   * So by filtering, we remove all the moved sections,since they no longer have
   * the same `parentTopicId`.
   */ const filteredSections = useMemo(()=>{
        return sections.filter((section)=>{
            var ref;
            return ((ref = section.parentTopic) === null || ref === void 0 ? void 0 : ref.id) === topicId;
        });
    }, [
        sections,
        topicId
    ]);
    const handlePerformAction = useCallback((command, activeItem)=>{
        if (!isPartOfTopic) return false;
        switch(command){
            case "EXPAND":
            case "COLLAPSE":
                if (activeItem) {
                    handleExpand(activeItem, command === "EXPAND");
                    return true;
                }
                return false;
            case "EDIT_TOPIC":
                {
                    if (!activeItem) return false;
                    const variant = getIsLargePointerDevice() ? "desktop" : "mobile";
                    dispatch({
                        type: "SET_EDITOR",
                        payload: {
                            editorPosition: activeItem.id,
                            editor: "EDIT_TOPIC",
                            variant
                        }
                    });
                    return true;
                }
            default:
                return false;
        }
    }, [
        dispatch,
        handleExpand,
        isPartOfTopic
    ]);
    const { Provider , navProps  } = useNavigationList(`TopicPageViewsTopicListSections|${topicId}`, useMemo(()=>({
            groupContainer: true,
            actions: SUPPORTED_ACTIONS,
            performSingularAction: handlePerformAction
        }), [
        handlePerformAction
    ]));
    return /*#__PURE__*/ _jsx(Flex, _objectSpread({
        flexDirection: "column"
    }, navProps, {
        children: /*#__PURE__*/ _jsx(Provider, {
            children: filteredSections.map((section, index)=>{
                const draggableId = String(section.id);
                return /*#__PURE__*/ _jsx(TopicPageViewsTopicListSectionWithListNavigation, {
                    __hideLater: __hideLater,
                    section: section,
                    isExpandable: expandable !== draggableId,
                    index: index,
                    isSortEnabled: isSortEnabled
                }, draggableId);
            })
        })
    }));
};
export default /*#__PURE__*/ memo(TopicPageViewsTopicListSections);
